import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SaveIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox='0 0 22 22'
      sx={{ height: '22px', width: '22px', fill: 'transparent', ...sx }}
      {...props}
    >
      <path
        d='M6.41667 2.75V5.86667C6.41667 6.38005 6.41667 6.63674 6.51658 6.83282C6.60446 7.00531 6.74469 7.14554 6.91718 7.23342C7.11326 7.33333 7.36995 7.33333 7.88333 7.33333H14.1167C14.63 7.33333 14.8867 7.33333 15.0828 7.23342C15.2553 7.14554 15.3955 7.00531 15.4834 6.83282C15.5833 6.63674 15.5833 6.38005 15.5833 5.86667V3.66667M15.5833 19.25V13.3833C15.5833 12.87 15.5833 12.6133 15.4834 12.4172C15.3955 12.2447 15.2553 12.1045 15.0828 12.0166C14.8867 11.9167 14.63 11.9167 14.1167 11.9167H7.88333C7.36995 11.9167 7.11326 11.9167 6.91718 12.0166C6.74469 12.1045 6.60446 12.2447 6.51658 12.4172C6.41667 12.6133 6.41667 12.87 6.41667 13.3833V19.25M19.25 8.54836V14.85C19.25 16.3901 19.25 17.1602 18.9503 17.7485C18.6866 18.2659 18.2659 18.6866 17.7485 18.9503C17.1602 19.25 16.3901 19.25 14.85 19.25H7.15C5.60986 19.25 4.83978 19.25 4.25153 18.9503C3.73408 18.6866 3.31338 18.2659 3.04973 17.7485C2.75 17.1602 2.75 16.3901 2.75 14.85V7.15C2.75 5.60986 2.75 4.83978 3.04973 4.25153C3.31338 3.73408 3.73408 3.31338 4.25153 3.04973C4.83978 2.75 5.60986 2.75 7.15 2.75H13.4516C13.9001 2.75 14.1243 2.75 14.3353 2.80066C14.5223 2.84557 14.7012 2.91964 14.8652 3.02016C15.0502 3.13354 15.2087 3.29208 15.5258 3.60915L18.3908 6.47418C18.7079 6.79126 18.8665 6.9498 18.9798 7.13481C19.0804 7.29884 19.1544 7.47768 19.1993 7.66474C19.25 7.87574 19.25 8.09994 19.25 8.54836Z'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgIcon>
  );
};

export default SaveIcon;
